module.exports = __webpack_public_path__ + "static/linear-logo-animation-1ea85168b6b09939f3bdb80e00d75890.webm";